import classNames from 'classnames';
import React, { ReactNode } from 'react';
import Box, { BoxProps } from 'ui-box';
import { majorScale } from '.';

export interface IKeyValueProps extends BoxProps<any> {
  keyName: ReactNode | string;
  value?: ReactNode | null;
  placeholder?: string;
  mono?: boolean;
}

export const KeyValue: React.FC<IKeyValueProps> = ({
  keyName,
  value = null,
  placeholder = 'Ikke angivet',
  mono = false,
  ...props
}) => (
  <Box
    {...props}
    width="100%"
    display="flex"
    alignItems="flex-start"
    marginY={majorScale(1)}
  >
    <Box width="40%" className="p muted">
      {keyName}
    </Box>
    {value !== null && value !== undefined && value !== '' && (
      <Box
        width="60%"
        className={classNames('p', mono && 'font-mono')}
        fontWeight={mono ? 600 : 500}
        whiteSpace="pre-line"
      >
        {value}
      </Box>
    )}
    {placeholder && !(value !== null && value !== undefined && value !== '') && (
      <Box className="p muted" width="60%">
        {placeholder}
      </Box>
    )}
  </Box>
);
